import serviceClient from '../../service-client/service-client';

const createSiteBackup = (options) => () => {
  const apiClient = serviceClient.get();
  return apiClient.createSiteBackup(options);
};

export default createSiteBackup;
